<app-nav-top></app-nav-top>
<router-outlet></router-outlet>
<app-footer class="footer"></app-footer>
